import PropTypes from 'prop-types'
//import { delay } from 'redux-saga'

import createForm from './create-form'

export const NEWSLETTER_OPTIONS_MALE = "Men";
export const NEWSLETTER_OPTIONS_FEMALE = "Women";
export const NEWSLETTER_OPTIONS = [NEWSLETTER_OPTIONS_FEMALE, NEWSLETTER_OPTIONS_MALE];

const isEmailValid = (email) => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(email)
const missingText = 'This field is required'

const formOptions = (id) => ({

    id: id,

    propTypes: {
        email: PropTypes.string,
        gender: PropTypes.string
    },

    defaults: {
        email: '',
        gender: NEWSLETTER_OPTIONS_FEMALE,
        submitted: false
    },

    validate: (values) => ({
        email: !values.email ? missingText : (!isEmailValid(values.email) ? 'Invalid e-mail' : null),
        gender: !values.gender ? missingText : null
    }),

    submit: function * () {

        const values = yield this.get('values');
        const {email, gender} = values;

        var response = yield fetch('https://eve.theiconic.com.au/customer/newsletter', {
            method: 'post',
            headers: {
                'Accept': 'application/json, application/xml, text/play, text/html, *.*',
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: `email=${email}&gender=${gender === NEWSLETTER_OPTIONS_MALE ? 'male' : 'female'}&source=edition`
        });

        const data = yield response.json();
        if(data.status >= 300)
            throw Error('Invalid e-mail');

        // either return the response:
        return { account: data }
    },

    success: function * (response) {
        yield response;
    },

    failure: function * (error) {
        yield error;
    }
});

export const formInPage = createForm(formOptions("newsletter"))
export const formFooter = createForm(formOptions("newsletter-footer"))


// WEBPACK FOOTER //
// ./src/components/Newsletter/formFooter.js